import { motion } from "framer-motion";
import { Heart, ArrowUpRight } from "lucide-react";
import { IMAGES, EVENT, DONATION_URL } from "@/lib/siteData";
import { StiftungChance } from "@/components/site/StiftungChance";

export const Footer = () => {
  return (
    <footer id="spenden" className="relative overflow-hidden bg-ink px-4 sm:px-6 pt-28 pb-14" data-testid="site-footer">
      <div className="pointer-events-none absolute -bottom-32 left-1/2 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-magenta/15 blur-[130px]" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-24">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-cyan mb-6">Jeder Franken zählt</p>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight text-ivory leading-[1.02]">
              Helfen. Hoffen.<br />Chancen schenken.
            </h2>
            <p className="mt-8 max-w-md text-ivory/60 leading-relaxed">
              Der Reinerlös des Anlasses kommt vollumfänglich der <StiftungChance label={EVENT.beneficiary} testid="footer-stiftung-link" className="text-ivory/80" /> zugute.
            </p>
            <motion.a
              whileTap={{ scale: 0.97 }}
              href={DONATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-magenta px-8 py-4 text-sm font-medium text-white transition-colors duration-300 hover:bg-violet"
              data-testid="footer-donate-button"
            >
              <Heart size={16} />
              Direkt bei Stiftung Chance spenden
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </motion.a>
            <p className="mt-5 text-sm text-ivory/60" data-testid="donation-note">
              Bei Bemerkung gerne «JCI Social Impact» eintragen.
            </p>
          </div>

          <div className="flex flex-col justify-between gap-10">
            <div className="rounded-2xl bg-white/95 p-6">
              <img src={IMAGES.logo} alt="JCI FRZ Social Impact x Stiftung Chance" className="w-full max-w-md" />
            </div>
            <p className="font-display text-2xl text-ivory/80 italic">Gemeinsam für kranke Kinder.</p>
          </div>
        </div>

        <div className="mt-24 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-ivory/40">
            © {new Date().getFullYear()} {EVENT.host} × <StiftungChance label={EVENT.beneficiary} testid="footer-copyright-stiftung-link" className="text-ivory/40 decoration-ivory/30" />
          </p>
          <p className="text-sm text-ivory/40">{EVENT.date} · {EVENT.location}, {EVENT.city}</p>
        </div>
      </div>
    </footer>
  );
};
